import Vue from "vue";
import VueRouter from "vue-router";
import constant from "../main.constants";
import fraudRoutes from "./fraud.routes";
import amlRoutes from "./aml.routes";
import examRoutes from "./exam.routes";
Vue.use(VueRouter);

import store from "../store";

const globalLoadingState = Vue.observable({
  isLoading: false
});

Vue.prototype.$globalLoading = globalLoadingState;

let otherRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => {
      // Furkan - Degiskenle kontrol edildiginde runtime'a düsecegi icin bu sekilde kontrol edildi. 
      // Environment'a göre farklı login sayfaları yükleniyor, gerek görülürse separateLoaderEnvHelper.js'e taşınabilir.
      switch (process.env.VUE_APP_ENVIRONMENT) {
        case 'Jandarma':
          return import("../views/auth/JandarmaLogin.vue");
        case 'Gumruk':
          return import("../views/auth/GumrukLogin.vue");
        // Tkpay testlerinden sonra açılacak
        // case 'Tkpay':
        //   return import("../views/auth/TkpayLogin.vue");
        default:
          return import("../views/auth/Login.vue");
      }
    }
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: () => import("../views/ErrorPage.vue"),
    props: { errorMessage: "forbiddenPage", errorCode: "403" }
  },
  {
    path: "*",
    component: () => import("../views/ErrorPage.vue"),
    props: { errorMessage: "pageNotFound", errorCode: "404" }
  },
  {
    path: "/spacegraph/viewer/:layoutId",
    name: "SpaceGraphViewer",
    props: true,
    component: () => import("../views/SpaceGraphViewerPage.vue"),
  },
  {
    path: "/auth/callback",
    name: "Callback",
    component: () => import("../views/auth/Callback.vue")
  },
  {
    path: "/tkpaylogin",
    name: "TkpayLogin",
    component: () => import("../views/auth/TkpayLogin.vue")
    // Tkpay testlerinden sonra kaldırılacak
  },
];

const environmentRoutes = [];
if (process.env.VUE_APP_ENVIRONMENT !== "Jandarma") {
  environmentRoutes.push({
    path: "/graphQuery",
    name: "GraphQuery",
    component: () => import("../views/GraphQuery.vue")
  });
}

otherRoutes = [...otherRoutes, ...environmentRoutes];

const router = new VueRouter({
  routes: otherRoutes
});

const addApplicationModeRoutes = (applicationMode) => {
  const tempRouter = new VueRouter({
    routes: otherRoutes
  });
  router.matcher = tempRouter.matcher;
  switch (applicationMode) {
    case constant.APPLICATIONMODE.AML:
      router.addRoutes([...amlRoutes, ...examRoutes]);
      break;
    case constant.APPLICATIONMODE.FRAUD:
      const homeRedirect = {
        path: "/",
        name: "Home",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
          managementComponent: () => import("../views/fraud/FraudIncidentManagement.vue"),
          isServiceEntityRequired: true
        },
        meta: {
          layout: () => import("../components/layouts/FraudLayout.component.vue"),
          icon: "mdi-calendar",
          localize: "fraud.incidents.title",
          isEntitySelectionEnabled: true
        }
      };

      router.addRoutes([homeRedirect, ...fraudRoutes]);
      break;
    case constant.APPLICATIONMODE.MIXED:
      router.addRoutes([...amlRoutes, ...fraudRoutes, ...examRoutes]);
      break;
  }
};

if (localStorage.clientSettings) {
  const clientSettings = JSON.parse(localStorage.clientSettings);
  const applicationModeInt = parseInt(clientSettings.ApplicationMode);
  addApplicationModeRoutes(applicationModeInt);
}

router.beforeEach((to, from, next) => {
  const token = localStorage.access_token;
  if (to.path !== from.path) {
    globalLoadingState.isLoading = true;
  }
  if (localStorage.applicationMode == constant.APPLICATIONMODE.MIXED && to.name == "Home" && localStorage.selectedApp == constant.APPLICATIONMODE.FRAUD) {
    next({ name: 'IncidentManagements' });
  }
  // TODO ktolga: Tkpay testlerinden sonra tkpaylogin kaldırılacak
  else if (to.name !== 'Login' && to.name !== 'TkpayLogin' && to.name !== 'GraphQuery' && to.path !== '/auth/callback' && (!token)) {
    const preferredLanguage = localStorage.getItem("preferredLanguage");
    localStorage.clear();
    localStorage.setItem("preferredLanguage", preferredLanguage);
    store.dispatch('commonStates/clearRouteHistory');
    next({ name: 'Login' });
  } else if (token && to.name === 'Login') {
    next({ name: 'Home' });
  }
  else {
    // todo: duygu from.name == null ise sayfa refreshi ya da sayfanın ilk açılması
    // signalR sayfa açık değilken bildirimi arttıramadığı için bildiirmlerim sayısının veritabanından çekilip localstorage yazılması gerekmekte
    // if the user is not authenticated, `next` is called twice
    next();
  }
})

/* 
  This function was added to manage the loading state after each route change
  After logging-in, due js files are not cached; it loads them and loading does not appears for a while, rel: bug/11371
  TODO: Applying g-zip operation of these files might increase loading of this files dramatically
*/
router.afterEach(() => {
  requestAnimationFrame(() => {
    globalLoadingState.isLoading = false;
  });
});

export { addApplicationModeRoutes };

export default router;
